module.exports = __webpack_public_path__ + "static/media/temp-foto-hero-mob-1.822e2a99.jpg";